<template lang="pug">
  .listTab02
    rankTabs(:taskList="taskList", :defaultTaskId="defaultTaskId")
    .dailyUpdate
      p(v-if="isInTaskPeriod") 最后更新：北京时间 {{lastUpdate}}
    .tabContent(v-if="isInTaskPeriod")
      ul.tabItemList
        v-touch(tag="li", v-for="board in currentLeaderBoards", :class="{active: board.id === currentTab}", @tap="changeTab(board.id)", :key="board.id")
          button {{board.name}}
      .itemlist-wrap(ref="containerTag", :style="'min-height:' + minHeight + 'px;'")
        transition(name="fade", mode="out-in")
          .itemTab01(v-for="(board, index) in currentLeaderBoards", v-if="board.id === currentTab", :key="board.id")
            transition(name="fade", mode="out-in")
              div(v-if="board.rank_list.length > 0")
                .rankIcon
                  .iconItem(:class="currentRankTab.suffix[index]")
                header {{campaign.info.dateRange}} {{board.name}}排名
                rankTable(:list="board.rank_list", :preferLength="board.rank_list.length < board.len ? board.len : board.rank_list.length")
              p.nullInfo(v-else) 暂无资料
    .dailyUpdate(v-else) 活动已结束！！！！！
    p.timeOut(v-if="isInTaskPeriod", style="white-space: pre-line;") {{currentRankTab.message.currentLeaderBoard}}
</template>

<script>
import rankTable from './rankTable'
import rankTabs from './rankTabs'
export default {
  props: ['lastUpdate', 'taskList'],
  components: {
    rankTable,
    rankTabs
  },
  created () {
    this.$bus.$on('rankTabOnChange', this.rankTabOnChange)
    this.rankTabOnChange(this.defaultTaskId)
  },
  data () {
    return {
      defaultTaskId: this.taskList[0].taskId,
      currentRankTab: null,
      currentLeaderBoards: null,
      campaign: null,
      minHeight: 100,
      currentTab: null
    }
  },
  methods: {
    changeTab (val) {
      this.currentTab = val
    },
    rankTabOnChange (taskId) {
      this.taskList.forEach(task => {
        if (task.taskId === taskId) {
          this.campaign = task
          this.currentLeaderBoards = task.currentLeaderBoard
          this.currentTab = this.currentLeaderBoards[0].id
          this.currentRankTab = task.rankTab
        }
      })
    }
  },
  computed: {
    isInTaskPeriod () {
      return +this.campaign.info.status < 2
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~breakpoint-sass/stylesheets/_breakpoint';
@import '../assets/styles/var';
@import '../assets/styles/base/base';
@import '../assets/styles/base/table';
.listTab02 {
  // padding-bottom: 40px;
  padding: 0px 10px;
  box-sizing: border-box;
  @include breakpoint(1024px) {
    padding: 0px;
  }
  .itemlist-wrap {
    padding: 15px;
    border-radius: 0px 0px 10px 10px;
    overflow: hidden;
    box-sizing: border-box;
    position: relative;
    header {
      text-align: center;
      font-weight: bold;
      margin-bottom: 15px;
      @include rem(font-size, 1.7rem);
      @include breakpoint(1024px){
        @include rem(font-size, 2.4rem);
      }
    }
  }
  .dailyUpdate {
    color: $black;
    text-align: center;
    font-weight: bold;
    margin: 10px 0px;
    @include rem(font-size, 1.6rem);
    @include breakpoint(768px){
      @include rem(font-size, 1.6rem);
    }
    @include breakpoint(1366px){
      @include rem(font-size, 2rem);
    }
  }
  .timeFinish {
    color: $black;
    text-align: center;
    margin-top: 10px;
    padding: 25px 0;
    font-weight: bold;
    @include rem(font-size, 1.8rem);
    @include breakpoint(1024px){
      padding: 100px 0;
      @include rem(font-size, 2.4rem);
    }
    // @include breakpoint($iSE_p){
    //   @include rem(font-size, 1.6rem);
    // }
    // @include breakpoint(1366px){
    //   @include rem(font-size, 2.4rem);
    // }
  }
  .timeOut {
    color: $gray;
    text-align: center;
    margin-top: 10px;
    padding: 25px 0;
    font-weight: bold;
    @include rem(font-size, 1.6rem);
    @include breakpoint(768px){
      @include rem(font-size, 1.6rem);
    }
    @include breakpoint(1024px){
      @include rem(font-size, 1.8rem);
    }
  }
}
.nullInfo{
  position: absolute;
  top: 50%;
  left : 50%;
  transform: translate(-50%, -50%);
}
.nullInfo {
  width: 100%;
  text-align: center;
  color: $black;
  margin: 0;
  @include rem(font-size, 1.8rem);
  @include breakpoint($iSE_p){
    @include rem(font-size, 1.6rem);
  }
  @include breakpoint(1366px){
    @include rem(font-size, 2.4rem);
  }
}

</style>



// WEBPACK FOOTER //
// src/components/currentLeaderBoard.vue